(function ($, njm) {
    'use strict';

    njm.views.heroOverlay = Backbone.View.extend({

        events: {
            'click .head': 'toggle',
            'click h2': 'toggle',
            'click .title': 'toggle'
        },

        /**
         * Initialize
         */
        //initialize: function () {
        //    this.$items = this.$('.item');
        //    this.$items.slice(0, 2).addClass('open');
        //},

        /**
         * Toggle
         * @param {Object} e
         */
        toggle: function (e) {
            $(e.currentTarget).closest('.item').toggleClass('open');
        }

    });
})(jQuery, njm);
